import {twMerge} from 'tailwind-merge';

export type InputProps = {
  className?: string;
  type?: string;
  variant: 'default' | 'minisearch' | 'newsletter' | 'form';
} & React.InputHTMLAttributes<HTMLInputElement>;

export function Input({className = '', type, variant, ...props}: InputProps) {
  const variants = {
    default:
      'bg-transparent py-3.5 px-7.5 text-black placeholder:text-gray-400 w-full focus:ring-0 border-0 transition focus:bg-gray/60 font-normal font-sans text-sm leading-[19px] border border-solid border-[1px] border-gray-100',
    minisearch:
      'bg-transparent hidden md:inline-block text-left lg:text-right border-b transition border-transparent -mb-px border-x-0 border-t-0 appearance-none px-0 py-1 focus:ring-transparent placeholder:opacity-20 placeholder:text-inherit',
    newsletter:
      'bg-transparent border border-gray-400 h-[45px] w-full xl:w-[315px] text-gray-400 focus:text-black focus:ring-transparent focus:bg-white focus:border-blue-500 focus:outline-none appearance-none pl-5 placeholder-gray-400',
    form: 'bg-transparent border border-gray-400 h-[45px] w-full text-gray-400 focus:text-black focus:ring-transparent focus:bg-white focus:border-blue-500 focus:outline-none appearance-none pl-5 placeholder-gray-400',
  };

  const styles = twMerge(variants[variant], className);

  return <input type={type} {...props} className={styles} />;
}
